<nz-modal [(nzVisible)]="isVisibleSupplierModal" [nzClassName]="'siteModal site-edit-modal'"
    [nzTitle]="siteNameTitleTemplate" (nzOnCancel)="handleCancel()" [nzFooter]="footerTpl">
    <ng-template #siteNameTitleTemplate>
        <div>
            Supplier : {{ selectedSupplierData.investorDisplayName }}
        </div>
    </ng-template>
    <ng-container *nzModalContent class="h-100">
        <div>
            <nz-tabset (nzSelectedIndexChange)="tabEvent($event)" [(nzSelectedIndex)]="tabIndex">
                <nz-tab nzTitle="Details">
                    <div class="page-padding"
                        style="overflow: auto;max-height: calc(100vh - 16em);;height: calc(100vh - 16em);">
                        <div nz-row class="d-flex align-i-c">
                            <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                                <h1 class="page-title-text tab-title">Investor Details</h1>
                            </div>
                        </div>
                        <nz-skeleton *ngIf="isLoadingData" [nzParagraph]="{ rows: 15 }" [nzActive]="true"></nz-skeleton>
                        <!-- <nz-spin [nzSpinning]="isLoadingData"> -->
                        <div class="detail-box h-max" nz-row *ngIf="!isLoadingData">
                            <div nz-col nzSpan="16">
                                <div nz-row>
                                    <div nz-col nzSpan="24" class="section-top-padding">
                                        <form nz-form [formGroup]="_fS.supplierDetailsForm">
                                            <div nz-row [nzGutter]="{ xs: 8, sm: 15, md: 15, lg: 20 }">
                                                <div class="upload" nz-col nzSpan="24">
                                                    <nz-avatar nzText="Supplier Logo" class="supplierLogoAvatar"
                                                        nzShape="square" (click)="file.click()"
                                                        (change)="onFileChanged($event)"
                                                        [nzSrc]="this.uploadResult ? this.uploadResult : null">
                                                    </nz-avatar>

                                                    <div class="d-flex">
                                                        <div nzMultiple="false" (click)="file.click()"
                                                            (change)="onFileChanged($event)">
                                                            <button nz-button nzMultiple="false"
                                                                [nzLoading]="isLoadingUpload" class="update-logo-btn">
                                                                <i nz-icon nzType="camera" nzTheme="outline"></i>
                                                                Add/Update Logo
                                                            </button>
                                                            <span class="supplierLogoText">Pixels: 800 x 400</span>
                                                        </div>
                                                        <input autocomplete="off" type="file"
                                                            (change)="onFileChanged($event)" #file hidden
                                                            nzTooltipTitle="prompt text" accept="image/*"
                                                            (click)="Onclick($event)" />
                                                        <a *ngIf="this.uploadResult" nz-popconfirm
                                                            nzPopconfirmTitle="Are you sure you want to delete the logo?"
                                                            nzPopconfirmPlacement="bottom"
                                                            (nzOnConfirm)="removeLogo()"><img
                                                                src="../../../../assets/images/delete.png"
                                                                class="delete-File ml-1 mt-10" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div nz-col nzSpan="24">
                                                    <nz-form-item>
                                                        <nz-form-control [nzErrorTip]="siteNameError">
                                                            <label class="label-text required">Supplier</label>
                                                            <input class="input-group" nz-input
                                                                formControlName="supplierName" />
                                                            <ng-template #siteNameError let-control>
                                                                <ng-container
                                                                    *ngIf="control.hasError('required')">Please
                                                                    enter
                                                                    supplier name
                                                                </ng-container>
                                                            </ng-template>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                                <div nz-col nzSpan="12">
                                                    <nz-form-item>
                                                        <nz-form-control [nzErrorTip]="agencyError">
                                                            <label class="label-text required">Agency</label>
                                                            <input class="input-group" nz-input
                                                                formControlName="agency" />
                                                            <ng-template #agencyError let-control>
                                                                <ng-container
                                                                    *ngIf="control.hasError('required')">Please
                                                                    enter
                                                                    agency name
                                                                </ng-container>
                                                            </ng-template>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                                <div nz-col nzSpan="12">
                                                    <nz-form-item>
                                                        <!-- [nzErrorTip]="supplierTypeErr" -->
                                                        <nz-form-control>
                                                            <label class="label-text">Supplier Type</label>
                                                            <nz-select nzShowSearch nzPlaceHolder="Select supplier type"
                                                                [nzSize]="'default'" formControlName="supplierType"
                                                                [nzSelectOnTab]="true">
                                                                <nz-option *ngFor="let option of listOfSupplierTypes"
                                                                    [nzLabel]="option.name"
                                                                    [nzValue]="option.id"></nz-option>
                                                            </nz-select>
                                                            <ng-template #supplierTypeErr let-control>
                                                                <!-- <ng-container
                                                                        *ngIf="control.hasError('required')">Please
                                                                        select
                                                                        supplier type
                                                                    </ng-container> -->
                                                            </ng-template>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
                                                    <nz-form-item>
                                                        <nz-form-control>
                                                            <label class="label-text">Document</label>
                                                            <nz-upload class="contact-upload" nzType="drag"
                                                                nzAccept=".pdf" [nzFileListRender]="fileListTpl"
                                                                [nzBeforeUpload]="beforeUpload" nzActions=""
                                                                (nzChange)="handleChangeBulkUpload($event)">
                                                                <p class="ant-upload-drag-icon">
                                                                    <span nz-icon nzType="inbox" class="fs-20"></span>
                                                                </p>
                                                                <p class="ant-upload-text">Click or drag file to
                                                                    this
                                                                    area to upload</p>
                                                            </nz-upload>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="6" nzXl="6">
                                                    <nz-form-item>
                                                        <nz-form-control [nzErrorTip]="contractDateError">
                                                            <label class="label-text"
                                                                [ngClass]="uploadedDocumentFile ? 'required': ''">Document
                                                                date</label>
                                                            <nz-date-picker formControlName="documentDate" class="w-100"
                                                                [nzAllowClear]="false"
                                                                [nzDisabled]="!uploadedDocumentFile"></nz-date-picker>
                                                            <ng-template #contractDateError let-control>
                                                                <ng-container
                                                                    *ngIf="control.hasError('required')">Please
                                                                    select
                                                                    contract date
                                                                </ng-container>
                                                            </ng-template>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="6" nzXl="6">
                                                    <label class="label-text">Assignment</label>
                                                    <nz-form-item>
                                                        <nz-form-control>
                                                            <!-- (ngModelChange)="getAssignmentUserDetails($event)" -->
                                                            <nz-select nzPlaceHolder="Select a user"
                                                                formControlName="assignment" [nzShowSearch]="true"
                                                                nzAllowClear [nzSelectOnTab]="true">
                                                                <nz-option *ngFor="let user of usersList"
                                                                    [nzValue]="user.id" [nzLabel]="user.name"
                                                                    [nzDisabled]="user.disabled">
                                                                </nz-option>
                                                            </nz-select>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                            </div>
                                            <div nz-row>
                                                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                                                    <div>
                                                        <ng-template #fileListTpl let-list>
                                                            <!-- <ng-container *ngFor="let item of uploadedContractFiles; let i = index"> -->
                                                            <p *ngIf="documentFile" class="item-name-text pt-0">
                                                                <a (click)="documentFile?.fileLink ? '' : $event.preventDefault()"
                                                                    [ngClass]="documentFile?.fileLink ? '' : 'cl-blk cursor-default'"
                                                                    [href]="documentFile?.fileLink" target="_blank">{{
                                                                    documentFile?.name }}</a>
                                                                <i nz-icon nzType="delete" class="fs-20 pl-15 cursor"
                                                                    nz-popconfirm
                                                                    nzPopconfirmTitle="Are you sure delete this file?"
                                                                    nzPopconfirmPlacement="bottom"
                                                                    (nzOnConfirm)="removeFile()"></i>
                                                            </p>
                                                            <!-- </ng-container> -->
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div nz-row [ngClass]="documentFile ? 'pt-18' : ''">
                                                <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="3" nzXl="3">
                                                    <label class="label-text required">Status</label>
                                                    <nz-form-item>
                                                        <nz-form-control>
                                                            <div class="d-flex align-i-c">
                                                                <nz-switch formControlName="status"></nz-switch>
                                                                <span class="pl-15">{{
                                                                    _fS.supplierDetailsForm.get('status')?.value == true
                                                                    ? 'Visible' : 'Hidden' }}</span>
                                                            </div>
                                                            <!-- <nz-radio-group formControlName="status">
                                                            <label nz-radio nzValue="1">Visible</label>
                                                            <label nz-radio nzValue="0">Hidden</label>
                                                        </nz-radio-group> -->
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                                <div nz-col nzXs="24" nzSm="24" nzMd="6" nzLg="6" nzXl="6">
                                                    <label class="label-text">Non-alc</label>
                                                    <nz-form-item>
                                                        <nz-form-control>
                                                            <label nz-checkbox formControlName="nonAlcStatus"></label>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div nz-col nzSpan="6" nzOffset="2" class="section-top-padding">
                                <div class="supplier-user-details">
                                    <nz-card nzHoverable *ngIf="!isLoadingData">
                                        <div class="detail-box-header">
                                            <h3 class="label-text pb-1">Company Billing</h3>
                                        </div>
                                        <div class="detail-box-content">
                                            {{selectedSupplierData?.companyName}}<br>
                                            {{selectedSupplierData?.streetAddress1}}<br>
                                            <span
                                                *ngIf="selectedSupplierData?.streetAddress2">{{selectedSupplierData?.streetAddress2}}<br></span>
                                            <span>{{selectedSupplierData?.city ? selectedSupplierData?.city : '' + '
                                                '}}
                                                {{selectedSupplierData?.state ? selectedSupplierData?.state : '' +
                                                '\
                                                '}}
                                                {{selectedSupplierData?.zipCode ? selectedSupplierData?.zipCode : ''
                                                +
                                                selectedSupplierData?.zipCode && selectedSupplierData?.country ? ',\
                                                ' :
                                                ''}}
                                                {{selectedSupplierData?.country ? selectedSupplierData?.country :
                                                ''}}</span>
                                        </div>
                                    </nz-card>
                                    <nz-card nzHoverable *ngIf="isLoadingData">
                                        <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 3 }" [nzAvatar]="false"
                                            [nzLoading]="isLoadingData">
                                        </nz-skeleton>
                                    </nz-card>
                                    <!-- </div> -->
                                    <!-- <div class="detail-box"> -->
                                    <!-- *ngIf="assignmentContact && !isLoadingAssignmentContact" -->
                                    <nz-card class="mt-2" nzHoverable
                                        *ngIf="selectedSupplierData?.firstName || selectedSupplierData?.lastName || selectedSupplierData?.email || selectedSupplierData?.phoneNumber">
                                        <div class="detail-box-header">
                                            <h3 class="label-text pb-1">AP Contact</h3>
                                        </div>
                                        <div class="detail-box-content">
                                            <span
                                                *ngIf="selectedSupplierData?.firstName || selectedSupplierData?.lastName">{{(selectedSupplierData?.firstName
                                                ? selectedSupplierData?.firstName : '') + ' ' +
                                                (selectedSupplierData?.lastName ? selectedSupplierData?.lastName :
                                                '')}}<br></span>
                                            <span
                                                *ngIf="selectedSupplierData?.email">{{selectedSupplierData?.email}}<br></span>
                                            <span
                                                *ngIf="selectedSupplierData?.phoneNumber">{{selectedSupplierData?.phoneNumber
                                                | mask: '(000) 000 - 0000'}}<br></span>
                                        </div>
                                    </nz-card>
                                    <nz-card class="mt-2" nzHoverable *ngIf="isLoadingAssignmentContact">
                                        <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 3 }" [nzAvatar]="false"
                                            [nzLoading]="isLoadingAssignmentContact">
                                        </nz-skeleton>
                                    </nz-card>
                                </div>
                            </div>
                        </div>
                        <!-- </nz-spin> -->
                    </div>
                </nz-tab>

                <nz-tab nzTitle="Investments">
                    <div class="page-padding"
                        style="overflow: auto;max-height: calc(100vh - 16em);height: calc(100vh - 16em);">
                        <div nz-row class="d-flex align-i-c">
                            <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                                <h1 class="page-title-text tab-title">Investor Requirements</h1>
                            </div>
                        </div>
                        <div class="detail-box h-max" style="min-height: 100%;" nz-row>
                            <div nz-col nzSpan="24">
                                <form nz-form [formGroup]="_fS.supplierRequirementForm">
                                    <div nz-row [nzGutter]="8">
                                        <div nz-col nzSpan="8">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <span
                                                        [ngClass]="_fS.supplierRequirementForm.value.isInvoice == true ? 'font-light': 'font-bold active' ">Estimate
                                                    </span>
                                                    <nz-switch class="switch-margin" formControlName="isInvoice">
                                                    </nz-switch><span
                                                        [ngClass]="_fS.supplierRequirementForm.value.isInvoice  != true ? 'font-light': 'font-bold vis-green active' ">
                                                        Invoice</span>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                    </div>
                                    <div nz-row [nzGutter]="8">
                                        <div nz-col nzSpan="6">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <label class="label-text">Primary Payment Method</label>
                                                    <nz-select nzPlaceHolder="Select payment method" nzShowSearch
                                                        [nzSize]="'default'" [nzAllowClear]="true"
                                                        formControlName="paymentMethod" [nzSelectOnTab]="true">
                                                        <nz-option *ngFor="let option of listOfPaymentMethods"
                                                            [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
                                                    </nz-select>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                        <div nz-col nzSpan="6">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <label class="label-text">Terms</label>
                                                    <nz-select nzPlaceHolder="Select terms" [nzSize]="'default'"
                                                        formControlName="terms" [nzAllowClear]="true" nzShowSearch
                                                        [nzSelectOnTab]="true">
                                                        <nz-option *ngFor="let option of listOfTerms"
                                                            [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
                                                    </nz-select>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                        <div nz-col nzSpan="6">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <label class="label-text">Fiscal start</label>
                                                    <nz-select nzPlaceHolder="Select fiscal start" [nzSize]="'default'"
                                                        [nzAllowClear]="true" formControlName="fiscalStart" nzShowSearch
                                                        [nzSelectOnTab]="true">
                                                        <nz-option *ngFor="let month of months" [nzLabel]="month"
                                                            [nzValue]="month"></nz-option>
                                                    </nz-select>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                    </div>
                                    <div nz-row [nzGutter]="8">
                                        <div nz-col nzSpan="24">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <label class="label-text">Supplier description</label>
                                                    <textarea type="text" placeholder="Enter supplier description"
                                                        class="input-group" nz-input formControlName="desc"
                                                        [nzAutosize]="{ minRows: 4, maxRows: 6 }"
                                                        maxlength="1000"></textarea>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                    </div>
                                    <div nz-row [nzGutter]="8">
                                        <div nz-col nzSpan="24">
                                            <nz-form-item>
                                                <nz-form-control>
                                                    <label class="label-text">Supplier notes</label>
                                                    <textarea type="text" class="input-group"
                                                        placeholder="Enter supplier notes" nz-input
                                                        formControlName="notes"
                                                        [nzAutosize]="{ minRows: 4, maxRows: 6 }"
                                                        maxlength="1000"></textarea>
                                                </nz-form-control>
                                            </nz-form-item>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </nz-tab>
                <nz-tab *ngIf="!isInternationalBrand" nzTitle="Retail" [nzDisabled]="!canViewRetailProgram">
                    <div class="page-padding"
                        style="overflow: auto;height: calc(100vh - 16em);max-height: calc(100vh - 16em);">
                        <div nz-row class="d-flex align-i-c">
                            <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                                <h1 class="page-title-text tab-title">Retail Supplier Codes</h1>
                            </div>
                        </div>
                        <div class="detail-box p-2 h-max" style="min-height: 100%;" nz-row>
                            <div nz-col nzSpan="24" *ngIf="!isLoadingData">
                                <div nz-row [nzGutter]="8" *ngFor="let program of retailPrograms; let i = index"
                                    class="p-1">
                                    <div nz-col nzSpan="6">
                                        <div class="d-flex justify-content-space-between">
                                            <div><label class="label-text">{{program.name}}</label></div>
                                            <div>
                                                <span *ngIf="program.selectedCode" nz-typography nzCopyable
                                                    [nzContent]="program.selectedCode">
                                                    {{program.selectedCode}}
                                                </span>
                                            </div>
                                        </div>
                                        <nz-select nzPlaceHolder="Select supplier code" [nzSize]="'default'"
                                            [nzAllowClear]="true" [nzSelectOnTab]="true" nzShowSearch
                                            [(ngModel)]="program.selectedCode"
                                            [nzDisabled]="program.isAssigned || !(canAddRetailProgram || canEditRetailProgram)"
                                            (ngModelChange)="setSupplierCodeToProgram($event, program)">
                                            <nz-option *ngFor="let option of program.codes"
                                                [nzLabel]="option.code + ' (' + option.companyName + ')'"
                                                [nzValue]="option.code" [nzDisabled]="option.isAssigned"></nz-option>
                                        </nz-select>
                                    </div>
                                </div>
                            </div>
                            <div nz-col nzSpan="24" *ngIf="isLoadingData">
                                <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 15 }" [nzAvatar]="false"
                                    [nzLoading]="isLoadingData"></nz-skeleton>
                            </div>
                        </div>
                    </div>
                </nz-tab>
            </nz-tabset>
        </div>
    </ng-container>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end footer-box">
            <div class="ant-drawer-footer">
                <button nz-button nzType="default" (click)="handleCancel()" class="dlt-btn width-100">Cancel</button>
                <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="this.isSavingSupplier"
                    class="medium-btn small-btn width-100 ">Save and Close</button>
            </div>
        </div>
    </ng-template>
</nz-modal>